import React, { forwardRef } from 'react';

const switchStyle = {
    display: 'inline-flex',
    height: '1.5rem',
    width: '2.75rem',
    flexShrink: 0,
    cursor: 'pointer',
    alignItems: 'center',
    borderRadius: '9999px',
    border: '2px solid transparent',
    transition: 'background-color 0.2s',
    outline: 'none',
    position: 'relative'
};

const thumbStyle = {
    pointerEvents: 'none',
    display: 'block',
    height: '1.25rem',
    width: '1.25rem',
    borderRadius: '9999px',
    backgroundColor: '#ffffff',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.2s',
    position: 'absolute',
    top: '0',
    left: '0' // We manage translate manually
};

const Switch = forwardRef(({ className, checked, onCheckedChange, style, ...props }, ref) => {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            onClick={() => onCheckedChange?.(!checked)}
            ref={ref}
            style={{
                ...switchStyle,
                backgroundColor: checked ? '#2563eb' : '#e5e7eb', // blue-600 vs gray-200
                ...style
            }}
            {...props}
        >
            <span
                style={{
                    ...thumbStyle,
                    transform: checked ? 'translateX(1.25rem)' : 'translateX(0)'
                }}
            />
        </button>
    );
});
Switch.displayName = "Switch";

export { Switch };
